import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrintService {
  private baseUrl: string = environment.baseApiUrl;

  constructor(private http: HttpClient) { }

  /**
   * Permet au client de récupérer un document PDF envoyé par le backend sous
   * forme de stream. Attention de vérifier le passage des variables. Notement
   * vérifier sous X3 que le nombre de variable est suffisant car limité.
   * @param companyCode Le code de la société pour définir le contexte au backend
   * @param customerCode Le code du client pour définir le contexte de récupération
   * @param document Le code du document à récupérer
   * @param documentType Le type de document (PDF, Excel, CSV, etc...)
   * @param documentPath L'emplacement du fichier (TODO à définir)
   * @param params Les paramètres sous forme de clés valeurs qui devront être dans l'ordre
   */
  public download(
    companyCode: string,
    customerCode: string,
    document: string,
    documentType: string,
    documentPath: string,
    ...params: string[]
  ): Observable<any> {
    // Temporaire pour grand livre client
    if (document === "AccountBook" && documentType==="PDF") {
      // AccountBook/Pdf?startDate=`+startDate+`&endDate=`+endDate
      documentType="Pdf";
      return this.http.get(
        `${
        this.baseUrl
        }/companies/${companyCode}/customers/${customerCode}/${document}/${documentType}?startDate=`+params[0]+`&endDate=`+params[1],
        { responseType: 'arraybuffer' }
      );
    } else {
      let paramString = "";
      for (let index = 0; index < params.length; index++) {
        if (index==0) {
          paramString+="?";
        } else {
          paramString+="&";
        }
        paramString+=`param${index}=`;
        paramString+=params[index];
      }
      return this.http.get(
        `${
        this.baseUrl
        }/companies/${companyCode}/customers/${customerCode}/${document}/${documentType}${paramString}`,
        { responseType: 'arraybuffer' }
      );
    }
  }
}
